$('.btn-inscribirse').on('click', function () {
    const slug = $(this).data('slug');
    $('#contenido-modal').html('<p>Cargando...</p>');
    $('#modal-inscripcion').css('display', 'block');	

    $.get('/actividades-agenda/' + slug + '/formulario', function (html) {
        $('#contenido-modal').html(html);
    });
});


// Cierre del modal si lo deseas
$(document).on('click', '.cerrar-modal', function () {
    $('#modal-inscripcion').hide();
});